import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ spacing, palette }) =>
  createStyles({
    root: {
      cursor: 'pointer',
      '& td': {
        backgroundColor: palette.background.default,
        borderBottom: '0px solid ' + palette.divider,
        padding: '1rem 0.5rem',
        maxWidth: 0,
        '&:first-child': {
          color: 'var(--text-title)',
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,
          paddingLeft: '2rem',
        },
        '&:last-child': {
          borderTopRightRadius: 5,
          borderBottomRightRadius: 5,
        },
      },
    },
    tags: {
      display: 'flex',
      gap: spacing(1.4),

      '& > span': {
        minWidth: '4.8rem',
        backgroundColor: '#DEE5DA',
        textAlign: 'center',
        padding: spacing(0.45, 0.8),
        borderRadius: spacing(0.5),
        fontSize: '12px',
      },
    },
    statusCell: {
      '& > div': {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '0.8rem',
        height: '2.3rem',
        padding: '0 0.8rem',
        marginRight: '2.4rem',
        color: '#ffffff',
        fontSize: '1.2rem',
        borderRadius: '5px',
        '& > span': {
          display: 'flex',
          alignItems: 'center',
          '& svg': {
            width: '1.4rem',
            height: '1.6rem',
          },
        },
      },
    },
    blueLabel: {
      backgroundColor: '#55AFCB',
      zIndex: 1,
      position: 'relative',
    },
    greenLabel: {
      backgroundColor: '#A0C84B',
      zIndex: 1,
      position: 'relative',
    },
    orangeLabel: {
      backgroundColor: '#FAAF32',
      zIndex: 1,
      position: 'relative',
    },
    redLabel: {
      backgroundColor: '#E64B32',
      zIndex: 1,
      position: 'relative',
    },
    tooltip: {
      backgroundColor: '#505356',
      color: '#FFFFFF',
      fontSize: '1.2rem',
      lineHeight: '1.5rem',
      padding: '0.7rem 2.5rem',
      border: 'none',
      borderRadius: 5,
      textAlign: 'center',
      maxWidth: '500px',
    },

    popper: {
      marginTop: '-20px',
    },
    tableItem: {
      borderCollapse: 'separate',
      '& > tbody > tr > td': {
        border: 'none',
      },
    },
    disabled: { cursor: 'not-allowed' },
    cellLayers: {
      padding: spacing(0, 0, 0.5),

      '& > a > div': {
        backgroundColor: '#F3F3F3',
        display: 'flex',
        alignItems: 'flex-end',
        gridGap: '1rem',

        padding: spacing(1.5, 2),
        border: 0,
        borderRadius: spacing(0.5),

        '& > h3': {
          flex: 1,
          fontSize: '1.6rem',
        },
      },
    },
  }),
)
